import React from 'react';

import { cva } from 'class-variance-authority';

import { cn } from '../../lib/utils';

import { useModalChrome } from './Modal';

const bodyVariants = cva('flex flex-1 flex-col overflow-y-auto', {
  variants: {
    padding: {
      // Make sure the scroll bar is flush with the right side and can go all the way to the bottom (so bottom right radius is clipping the scoller
      // and the content is not flush with the bottom)
      default: 'pt-5 [&>*]:px-4 md:[&>*]:px-6 [&>*]:pb-5',
      tiny: 'pt-5 [&>*]:px-4 md:[&>*]:px-6 [&>*]:pb-5',
      none: 'p-0',
    },
  },
  defaultVariants: {
    padding: 'default',
  },
});

const ModalBody = ({ children, className, padding, ...props }) => {
  const { padding: contextPadding } = useModalChrome();
  const resolvedPadding = padding ?? contextPadding;

  return (
    <div className={cn(bodyVariants({ padding: resolvedPadding }), className)} {...props}>
      {children}
    </div>
  );
};

export { ModalBody, bodyVariants };
